import React from "react";
import s from "./Title.module.scss";


export function Title(props){
    return <h1 className={s.title}>{props.title}</h1 >
}